module.exports = __webpack_public_path__ + "static/media/icon4.fd48c1cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/LAMI/icon4.svg
// module id = 95
// module chunks = 0